<template>
  <div>
    <header-bar>LinkMAP レポート一覧</header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="linkanalytic-search-wrap flex">
          <div class="linkanalytic-search-text">リリース検索</div>
          <form @submit.prevent="onClickedSearch">
            <input
              v-model="preKeyword"
              class="linkanalytic-search"
              type="search">
          </form>
          <a
            class="c-btn c-btn--search"
            @click.prevent="onClickedSearch">
            <img
              src="/img/common/icon-search.png"
              alt="">検索
          </a>
        </div>
      </div>
    </div>

    <div
      ref="pendingBlock"
      class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">LinkMAP レポート一覧</h3>
      </div>
      <div class="page-block__inner">
        <div class="c-table-caption">横にスクロールしてご覧ください</div>
        <div class="my-release-list">
          <link-analytic-index-table
            ref="pendingTable"
            :keyword="keyword"
            @on-pagination-clicked="scrollTo('pendingBlock')">
            <template v-slot:control1="slotProps">
              <div
                class="c-btn--note"
                @click.prevent="onLinkAnalyticDetailClicked(slotProps)">
              </div>
            </template>
            <template v-slot:control2="slotProps">
              <div
                v-if="isDeliveryStatus(slotProps)"
                class="c-btn--note"
                @click.prevent="onEditLinkClicked(slotProps)">
              </div>
              <div
                v-else
                class="c-btn--note-disabled">
              </div>
            </template>
            <template v-slot:control3="slotProps">
              <div
                v-if="isProductLinkDataExists(slotProps)"
                class="c-btn--note"
                @click.prevent="onShowLinkClicked(slotProps)">
              </div>
              <div
                v-else
                class="c-btn--note-disabled">
              </div>
            </template>
            <template #empty>
              <span v-if="keyword">このキーワードの</span>レポートはありません。
            </template>
          </link-analytic-index-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
  CMAP_RELEASE_STATUS_EDITING,
  CMAP_RELEASE_STATUS_REAPPLY,
  CMAP_RELEASE_STATUS_DSP_REAPPLY,
  CMAP_RELEASE_STATUS_APPEND_DSP,
  CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN,
  CMAP_RELEASE_STATUS_TAKE_DOWN,
  CMAP_RELEASE_STATUS_RELEASE_REJECTED,
  CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN,
} from '../../../consts/status'
import HeaderBar from '../HeaderBar'
import LinkAnalyticIndexTable from './LinkAnalyticIndexTable'

export default {
  name: 'LinkAnalyticIndex',
  components: {
    LinkAnalyticIndexTable,
    HeaderBar,
  },
  data() {
    return {
      keyword: '',
      preKeyword: '',
    }
  },
  methods: {
    onLinkAnalyticDetailClicked(products) {
      this.$router.push({ name: 'link-analytic-detail', params: { id: products.products.id } })
    },
    onShowLinkClicked(products) {
      window.open(products.products.product_link.url_full, '_blank')
    },
    onEditLinkClicked(products) {
      this.$router.push({ name: 'link-create', params: { id: products.products.id } })
    },
    onClickedSearch() {
      this.keyword = this.preKeyword
    },
    isProductLinkDataExists(products) {
      return products.products.product_link != null
    },
    isDeliveryStatus(products) {
      return products.products.release_status === CMAP_RELEASE_STATUS_DSP_IN_REVIEW
        || products.products.release_status === CMAP_RELEASE_STATUS_PUBLISHED
        || products.products.release_status === CMAP_RELEASE_STATUS_EDITING
        || products.products.release_status === CMAP_RELEASE_STATUS_REAPPLY
        || products.products.release_status === CMAP_RELEASE_STATUS_DSP_REAPPLY
        || products.products.release_status === CMAP_RELEASE_STATUS_APPEND_DSP
        || products.products.release_status === CMAP_RELEASE_STATUS_PREPARE_TAKE_DOWN
        || products.products.release_status === CMAP_RELEASE_STATUS_TAKE_DOWN
        || products.products.release_status === CMAP_RELEASE_STATUS_RELEASE_REJECTED
        || products.products.release_status === CMAP_RELEASE_STATUS_UPLOADING_TAKE_DOWN
    },
    scrollTo(elementName) {
      this.$refs[elementName].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
  },
}
</script>
